module.exports = __webpack_public_path__ + "img/surfen en duiken.35b63dd4.jpg";